import React from 'react';
import { Grid, Box, useMediaQuery, useTheme, Avatar } from '@mui/material';
import ForgetPasswordForm from '../components/ForgetPasswordForm';
import Layout from '../components/LayoutForm';
import { Link as RouterLink } from 'react-router-dom';

export default function HomePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Layout>
        <Box
          sx={{
            minHeight: '100vh',
            px: 2,
            pt: 8, // Espacio arriba (ajustable según el tamaño de tu header)
            pb: 6, // Espacio abajo por estética
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start', // Puedes usar 'center' si prefieres centrado vertical
            alignItems: 'center',
          }}
        >
          <ForgetPasswordForm />
        </Box>
      </Layout>
    );
  }


  // Layout dividido para pantallas grandes
  return (
    <Grid container sx={{ height: '100vh', overflow: 'hidden' }}>
      
      {/* Lado Izquierdo - fijo y centrado */}
      

      {/* Lado Derecho - scrollable */}
      <Grid
        item
        md={12}
        sx={{
          height: '100vh',
          overflowY: 'auto',
          backgroundColor: '#f9f9f9',
          width: '100%',
        }}
      >
        <Box
          sx={{
            minHeight: '100%',
            px: 4,
            py: 6,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            component={RouterLink}
            to="/"
            sx={{
              position: 'absolute',
              top: 24,
              left: 24,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src="/logo.png"
              alt="Rodaris"
              sx={{
                height: 30,
                width: 'auto',
              }}
            />
          </Box>
          <ForgetPasswordForm />
        </Box>
      </Grid>
    </Grid>
  );
}
